import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Sora, sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
          root: {
              boxShadow: "none",
              "&:hover": {
                  boxShadow: "none",
              }
          }
      }
    },
    MuiDivider: {
      styleOverrides: {
          root: {
              borderWidth: "0 0 thin 0 !important",
              borderColor: "#EFEDED",
              margin: "0",
          },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& input:-webkit-autofill": {
            backgroundColor: "transparent !important",
            boxShadow: "0 0 0px 1000px white inset !important",
            transition: "background-color 5000s ease-in-out 0s !important",
          },
          "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button": {
            "-webkit-appearance": "none",
            margin: 0,
          },
          "& input[type=number]": {
            "-moz-appearance": "textfield",
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          "& input:-webkit-autofill": {
            backgroundColor: "transparent !important",
            boxShadow: "0 0 0px 1000px white inset !important",
            transition: "background-color 5000s ease-in-out 0s !important",
          },
          "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button": {
            "-webkit-appearance": "none",
            margin: 0,
          },
          "& input[type=number]": {
            "-moz-appearance": "textfield", // Firefox ke liye
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& input:-webkit-autofill": {
            backgroundColor: "transparent !important",
            boxShadow: "0 0 0px 1000px white inset !important",
            transition: "background-color 5000s ease-in-out 0s !important",
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {        
        "::-webkit-scrollbar": {
          width: "4px",
          height: "3px",
        },
        "::-webkit-scrollbar-thumb": {
          backgroundColor: "#888",
          borderRadius: "4px",
        },
        "::-webkit-scrollbar-track": {
          backgroundColor: "#f1f1f1",
        },
      },
    },
  },
});

export default theme;
